require('./views/oauth_callback.html');

import {Routes, RouterModule, UrlSegment} from '@angular/router';

import { NgModule, enableProdMode }      from '@angular/core';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { FormsModule }   from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TransferHttpCacheModule } from '@nguniversal/common';
import {APP_BASE_HREF} from '@angular/common';

import {TooltipModule} from "ngx-tooltip";
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';

import { AppComponent }          from './app.component';
import { AuthComponent }         from './components/auth';
import { DocumentationComponent, OperationDocumentationComponent }       from './components/documentation';
import { MarkdownComponent } from './components/markdown';
import { ConsoleComponent }       from './components/console';
import { RecipeComponent }       from './components/recipe';
import { GalleryComponent }   from './components/gallery';
import { SideMenuComponent, SideMenuItemComponent }       from './components/side-menu';
import { NavbarComponent }       from './components/navbar';
import { FooterComponent }       from './components/footer';
import { SchemaComponent, SubschemaComponent }   from './components/schema';
import { SampleCodeComponent }   from './components/sample-code';
import { APICallComponent } from './components/api-call';
import { APIResponseComponent }   from './components/api-response';
import { DemoComponent }   from './components/demo';
import { ParameterComponent, ParameterSetComponent, ParameterGroupComponent, ParameterFilterPipe }    from './components/parameter';
import { SocialButtonsComponent }    from './components/social-buttons';
import { SearchResultsComponent } from './components/search-results';
import { JSONSchemaFormComponent } from './json-schema-form/json-schema-form.component';
import { SchemaLabelComponent } from './json-schema-form/schema-label.component';

import { appRoutes } from './app.routing';
import { RoutesService } from './services/routes';
import { UtilsService } from './services/utils';
import { TrackerService } from './services/tracker';
import { SecretService } from './services/secret';
import { OpenAPIService } from './services/openapi';
import { GitHubService } from './services/github';
import { MenuService, GetMenuItemFromSearchPipe, MapSearchResultsPipe } from './services/menu';
import { SearchService } from './services/search';
import { TourService } from './services/tour';
import { PlatformService } from './services/platform.service';

enableProdMode();

declare let window:any;
window.originalURL = {
  path: window.location.pathname,
  hash: window.location.hash,
}
window.config = window.config || {};

@NgModule({
  imports: [
    HttpClientModule,
    FormsModule,
    BrowserModule.withServerTransition({ appId: 'lucybot-doc-app' }),
    BrowserTransferStateModule,
    TransferHttpCacheModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, {useHash: false}),
    TooltipModule,
    Ng2DatetimePickerModule,
    VirtualScrollerModule,
  ],
  providers: [
    {provide: APP_BASE_HREF, useValue: window.config.basePath || '/'},
    { provide: 'ORIGIN_URL', useValue: '' },
    RoutesService,
    UtilsService,
    TrackerService,
    SecretService,
    OpenAPIService,
    GitHubService,
    MenuService,
    SearchService,
    TourService,
    PlatformService,
  ],
  declarations: [
    AppComponent,
    DocumentationComponent,
    ConsoleComponent,
    RecipeComponent,
    GalleryComponent,
    MarkdownComponent,

    AuthComponent,
    OperationDocumentationComponent,
    SideMenuComponent,
    SideMenuItemComponent,
    NavbarComponent,
    FooterComponent,
    SchemaComponent,
    SubschemaComponent,
    APICallComponent,
    SampleCodeComponent,
    APIResponseComponent,
    DemoComponent,
    ParameterComponent,
    ParameterSetComponent,
    ParameterGroupComponent,
    SocialButtonsComponent,
    SearchResultsComponent,
    JSONSchemaFormComponent,
    SchemaLabelComponent,

    ParameterFilterPipe,
    MapSearchResultsPipe,
    GetMenuItemFromSearchPipe,
  ],
  bootstrap: [ AppComponent ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts